export const LANGS = ["it", "fr", "de", "es"];
export const DEFAULT_LANG = "it";

export const SLUGS = {
  it: { home: "", about: "chi-siamo", activities: "attivita", projects: "progetti", laRomana: "progetti/la-romana", villa: "progetti/villa-bevilacqua", team: "team", gallery: "galleria", donate: "donazioni", contact: "contatti", privacy: "privacy", cookies: "cookie" },
  fr: { home: "", about: "qui-sommes-nous", activities: "activites", projects: "projets", laRomana: "projets/la-romana", villa: "projets/villa-bevilacqua", team: "equipe", gallery: "galerie", donate: "dons", contact: "contact", privacy: "confidentialite", cookies: "cookies" },
  de: { home: "", about: "ueber-uns", activities: "aktivitaeten", projects: "projekte", laRomana: "projekte/la-romana", villa: "projekte/villa-bevilacqua", team: "team", gallery: "galerie", donate: "spenden", contact: "kontakt", privacy: "datenschutz", cookies: "cookies" },
  es: { home: "", about: "quienes-somos", activities: "actividades", projects: "proyectos", laRomana: "proyectos/la-romana", villa: "proyectos/villa-bevilacqua", team: "equipo", gallery: "galeria", donate: "donaciones", contact: "contacto", privacy: "privacidad", cookies: "cookies" },
};

export const pathFor = (lang, key) => {
  const slug = SLUGS[lang]?.[key];
  return `/${lang}/${slug ? slug : ""}`;
};

export const keyFromSlug = (lang, slug) => {
  const clean = (slug || "").replace(/^\/+|\/+$/g, "");
  const hit = Object.entries(SLUGS[lang] || {}).find(([, v]) => v === clean);
  return hit ? hit[0] : null;
};
